import { defineMessages } from "react-intl";

export const texts = defineMessages({
  otherOptionPlaceholder: {
    defaultMessage: "Please type another option here",
    id: "XYhybg",
  },
  other: {
    defaultMessage: "Other",
    id: "/VnDMl",
  },
  required: {
    defaultMessage: "Description is required",
    id: "+NKkKd",
  },
});
